import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useSelector, useDispatch } from "react-redux";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import CommonDropdown from "../../../components/commonDropDown/CommonDropDown";
import { education, experience, workYears } from "../../../constants/constants";
import { updateStep, clearValidation } from "../../../redux/profileFormSlice";
import ValidationError from "../../../components/ValidationError/ValidationError";

const schema = yup.object({
  education: yup.string().required("Highest education level is required"),
  status: yup.string().required("Employment status is required"),
  experience: yup.string().required("Professional experience is required"),
  workYears: yup.string().required("Years of work experience is required"),
});

const EducationProfessional = () => {
  const dispatch = useDispatch();
  const stepData = useSelector((state) => state.profileForm.step4);
  const validationStep = useSelector((state) => state.profileForm.validationStep);

  const {
    register,
    watch,
    trigger,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    mode: "onChange",
    defaultValues: {
      education: stepData?.education || "",
      status: stepData?.status || "",
      experience: stepData?.experience || "",
      workYears: stepData?.workYears || "",
    },
  });

  useEffect(() => {
    const subscription = watch((values) => {
      dispatch(updateStep({ step: "step4", data: values }));
    });
    return () => subscription.unsubscribe();
  }, [watch, dispatch]);

  useEffect(() => {
    if (validationStep === 4) {
      trigger();
      dispatch(clearValidation());
    }
  }, [validationStep, trigger, dispatch]);

  const hasErrors = Object.keys(errors).length > 0;

  return (
    <div>
      <div className="text-center mb-5">
        <h3 className="text-lg sm:text-xl font-bold text-gray-800">Education & Professional</h3>
        <p className="text-xs sm:text-sm text-gray-500">Share your educational background and work experience</p>
      </div>

      <ValidationError message={hasErrors ? "Please fill in all required fields" : null} />

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6">
        <CommonDropdown name="education" label="Highest Education Level" register={register} errors={errors} options={education} required defaultValue={stepData?.education} />
        <CommonDropdown name="status" label="Employment Status" register={register} errors={errors} options={experience} required defaultValue={stepData?.status} />
        <CommonDropdown name="experience" label="Professional Experience" register={register} errors={errors} options={experience} required defaultValue={stepData?.experience} />
        <CommonDropdown name="workYears" label="Years of Work Experience" register={register} errors={errors} options={workYears} required defaultValue={stepData?.workYears} />
      </div>
    </div>
  );
};

export default EducationProfessional; 